<template>
  <v-dialog v-model="dialog" width="600px" v-if="currentUID == uid">
    <template v-slot:activator="{ on }">
      <button
        type="button"
        v-on="on"
        class="h-[34px] px-4 py-[7px] bg-[#8056dd] justify-center items-center inline-flex rounded-md"
      >
       
      <svg xmlns="http://www.w3.org/2000/svg" width="1.3em" height="1.3em" viewBox="0 0 24 24"><path fill="white" d="m12.89 3l1.96.4L11.11 21l-1.96-.4zm6.7 9L16 8.41V5.58L22.42 12L16 18.41v-2.83zM1.58 12L8 5.58v2.83L4.41 12L8 15.58v2.83z"/></svg>
      
      </button>
    </template>
    <dialog-card title="Embed Widget" @close="dialog = false" :isSubmit="false">
      <please-wait v-if="isLoading"></please-wait>
      <template v-else>
        <!-- Iframe Code Section - Moved to Top -->
        <div class="mb-6">
          <h4 class="text-sm font-semibold text-gray-700 mb-2">Your Embed Code:</h4>
          <div class="bg-gray-100 border border-gray-300 rounded-lg p-3 mb-3">
            <code class="text-sm text-gray-800 break-all">{{ iframe }}</code>
          </div>
          <div class="d-flex justify-end">
            <v-btn @click="copy()" text color="green" class="font-medium">
              <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"></path>
              </svg>
              Copy to Clipboard
            </v-btn>
          </div>
        </div>

        <!-- Instructions Section -->
        <div class="mb-4">
          <h3 class="text-lg font-semibold text-gray-800 mb-3">How to Embed Your Store Locator</h3>
          
          <!-- Step-by-step instructions -->
          <div class="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
            <h4 class="text-sm font-semibold text-blue-800 mb-2 flex items-center">
              <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
              Step-by-Step Instructions
            </h4>
            <ol class="text-sm text-blue-700 space-y-2">
              <li class="flex items-start">
                <span class="bg-blue-600 text-white rounded-full w-4 h-4 flex items-center justify-center text-xs font-bold mr-3 flex-shrink-0" style="min-width: 16px; min-height: 16px; max-width: 16px; max-height: 16px;">1</span>
                <span class="flex-1">Copy the iframe code below by clicking the "Copy Clipboard" button</span>
              </li>
              <li class="flex items-start">
                <span class="bg-blue-600 text-white rounded-full w-4 h-4 flex items-center justify-center text-xs font-bold mr-3 flex-shrink-0" style="min-width: 16px; min-height: 16px; max-width: 16px; max-height: 16px;">2</span>
                <span class="flex-1">Paste the code into your website's HTML where you want the store locator to appear</span>
              </li>
              <li class="flex items-start">
                <span class="bg-blue-600 text-white rounded-full w-4 h-4 flex items-center justify-center text-xs font-bold mr-3 flex-shrink-0" style="min-width: 16px; min-height: 16px; max-width: 16px; max-height: 16px;">3</span>
                <span class="flex-1">Customize the width and height attributes as needed for your layout</span>
              </li>
              <li class="flex items-start">
                <span class="bg-blue-600 text-white rounded-full w-4 h-4 flex items-center justify-center text-xs font-bold mr-3 flex-shrink-0" style="min-width: 16px; min-height: 16px; max-width: 16px; max-height: 16px;">4</span>
                <span class="flex-1">Save and publish your website to see the embedded store locator</span>
              </li>
            </ol>
          </div>

          <!-- Usage examples -->
          <div class="bg-green-50 border border-green-200 rounded-lg p-4 mb-4">
            <h4 class="text-sm font-semibold text-green-800 mb-2 flex items-center">
              <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
              Usage Examples
            </h4>
            <div class="text-sm text-green-700 space-y-2">
              <p><strong>Full Width:</strong> Use <code class="bg-green-100 px-1 rounded">width="100%"</code> for responsive design</p>
              <p><strong>Fixed Size:</strong> Use <code class="bg-green-100 px-1 rounded">width="800px" height="600px"</code> for specific dimensions</p>
              <p><strong>Responsive:</strong> Combine with CSS media queries for mobile optimization</p>
            </div>
          </div>

          <!-- Important notes -->
          <div class="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
            <h4 class="text-sm font-semibold text-yellow-800 mb-2 flex items-center">
              <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"></path>
              </svg>
              Important Notes
            </h4>
            <ul class="text-sm text-yellow-700 space-y-1">
              <li>• The iframe will automatically update when you make changes to your store locator configuration</li>
              <li>• Ensure your website allows iframe embedding (check with your hosting provider)</li>
              <li>• For better performance, consider lazy loading the iframe</li>
              <li>• The store locator is mobile-responsive and will adapt to different screen sizes</li>
            </ul>
          </div>
        </div>
      </template>
    </dialog-card>
  </v-dialog>
</template>

<script>
import { addDoc, getDocs, limit, query, where } from "firebase/firestore";
import DialogCard from "./ui/DialogCard.vue";
import PleaseWait from "./ui/PleaseWait.vue";
import { widget_keys } from "@/utils/firebase.utils";
export default {
  components: { DialogCard, PleaseWait },
  props: {
    type: {
      type: String,
      default: "dashboard",
    },
  },
  data() {
    return {
      dialog: false,
      isLoading: true,
      widgetKey: "",
    };
  },
  computed: {
    iframe() {
      let url = `${location.origin}/widgets/${this.type}/${this.widgetKey}?ch=8050DE`;
      return `<iframe src="${url}" width="100%" height="100%" style="border:0px"></iframe>`;
    },
  },
  methods: {
    copy() {
      navigator.clipboard.writeText(this.iframe);
      this.$snackbar.show("Embed Widget Copied to Clipboard");
    },

    async fetchWidgetKey() {
      try {
        this.isLoading = true;
        let wid = this.WID || "default";
        let uid = this.currentUID;
        let widgetQuery = query(
          widget_keys,
          where("uid", "==", uid),
          where("wid", "==", wid),
          limit(1)
        );
        let snap = (await getDocs(widgetQuery)).docs;
        if (snap.length == 0) {
          let widget = await addDoc(widget_keys, {
            uid: uid,
            wid: wid,
          });
          this.widgetKey = widget.id;
        } else {
          this.widgetKey = snap[0].id;
        }
        this.isLoading = false;
      } catch (error) {
        this.handleError(error);
      }
    },
  },
  mounted() {
    this.fetchWidgetKey();
  },
};
</script>

<style></style>
